package game.scenes;


import cerastes.SoundManager;
import data.Parts;
import cerastes.Utils;
import hxd.Key;
import cerastes.c2d.DebugDraw;


@:keep
class ShopScene extends LDScene
{

	override function enter()
	{
		super.enter();

		initUI( "ui/shop_scene.ui" );
		
		var root = s2d;
		cerastes.macros.UIPopulator.populateObjects();


		GameState.data.repair = 0;

		SoundManager.musicVol = 0.4;
		if( GameState.data.day % 2 == 1)
			SoundManager.playMusicFile("music/song_a.ogg");
		else 
			SoundManager.playMusicFile("music/song_b.ogg");



		createComponents();
	}


	override function tick( delta:Float )
	{
		super.tick(delta);

		//DebugDraw.text('${ Math.round( hxd.Timer.fps() )} fps');
	}

	override function exit()
	{
		super.exit();
	}


	override function preload()
	{
		super.preload();
	}
}
